import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  private scrollPositions: Map<string, number> = new Map();

  setScrollPosition(userId: string, position: number): void {
    this.scrollPositions.set(userId, position);
  }

  getScrollPosition(userId: string): number {
    return this.scrollPositions.get(userId) || 0;
  }
}
